import { call, race, delay, getContext } from "redux-saga/effects";
const contextKey = "__routingContext";
function* getRoutingContext() {
  const [ctx] = yield race([
    call(function* attemptToGetContext() {
      while (true) {
        const ctx2 = yield getContext(contextKey);
        if (ctx2) {
          return ctx2;
        }
        yield delay(10);
      }
    }),
    delay(1e3)
  ]);
  if (!ctx) {
    console.warn("timed out getting RoutingContext for sagas");
  }
  return ctx;
}
function* getUrlFormatter() {
  const routingContext = yield call(getRoutingContext);
  return routingContext.format;
}
function* pushLocation(url) {
  const routingContext = yield call(getRoutingContext);
  return yield call(routingContext.push, url);
}
function* replaceLocation(url) {
  const routingContext = yield call(getRoutingContext);
  return yield call(routingContext.replace, url);
}
export {
  contextKey,
  getUrlFormatter,
  pushLocation,
  replaceLocation
};
//# sourceMappingURL=routing.js.map
